import { JSX, useCallback } from "react";
import { useTranslation } from "react-i18next";

import Grid from "@mui/material/Grid";
import InputAdornment from "@mui/material/InputAdornment";
import Typography from "@mui/material/Typography";

import ManagedTextField from "utils/edit/ManagedTextField";
import { ChangeEvent } from "utils/history/Event";
import { asTitle } from "utils/Utils";

import { CalculationField } from "core/field/FieldService";
import { FormFieldExpansionProps } from "core/field/form/FormFieldRow";

export type CalculationFormFieldExpansionProps = FormFieldExpansionProps & {
	field: CalculationField;
};

export default function CalculationFormFieldExpansion(
	props: CalculationFormFieldExpansionProps
): JSX.Element {
	const { t } = useTranslation();

	const handleValueChange = useCallback(
		(value: string) => {
			const event = new ChangeEvent("/value", props.field.value, value);
			props.onChange(event);
		},
		[props.onChange, props.field.value]
	);

	return (
		<Grid container direction={"column"} alignItems="flex-start">
			<Grid item container alignItems="center">
				<Grid item xs={6} sm={4} md={3} lg={2}>
					<Typography variant="subtitle2">
						{asTitle(t("default"))}
					</Typography>
				</Grid>
				<Grid item xs={6} sm={8} md={9} lg={10}>
					<ManagedTextField
						id={props.field.name}
						variant="standard"
						fullWidth
						disabled={!props.editable}
						value={props.field.value ?? ""}
						InputProps={{
							startAdornment: (
								<InputAdornment position="start">
									=
								</InputAdornment>
							)
						}}
						onUpdate={handleValueChange}
					/>
				</Grid>
			</Grid>
		</Grid>
	);
}
